export const formConstant = {
    url: 'FORM.URL',
    preview: 'FORM.PREVIEW',
    importedForms: 'FORM.IMPORTED_FORMS',
    collectedResponses: 'FORM.COLLECTED_RESPONSES',
    deletionRequests: 'FORM.DELETION_REQUESTS',
    recentForms: 'FORM.RECENT_FORMS',
    responses: 'FORM.RESPONSES',
    response: 'FORM.RESPONSE',
    formType: 'FORM.FORM_TYPE',
    importedDate: 'FORM.IMPORTED_DATE',
    submittedForms: 'FORM.SUBMITTED_FORMS',
    responder: 'FORM.RESPONDER',
    requestedBy: 'FORM.REQUESTED_BY',
    responders: 'FORM.RESPONDERS',
    submissionDate: 'FORM.SUBMISSION_DATE',
    status: {
        pending: 'FORM.STATUS_PENDING',
        deleted: 'FORM.STATUS_DELETED',
        expired: 'FORM.STATUS_EXPIRED'
    },
    delete: 'FORM.DELETE',
    deleteDescription: 'FORM.DELETE_DESCRIPTION',
    hide: 'FORM.HIDE',
    hideDescription: 'FORM.HIDE_DESCRIPTION',
    pinned: 'FORM.PINNED',
    pinnedDescription: 'FORM.PINNED_DESCRIPTION',
    menu: {
        pinForm: 'FORM_MENU.PIN_FORM',
        visibility: 'FORM_MENU.VISIBILITY',
        deleteForm: 'FORM_MENU.DELETE_FORM',
        openFormulierenExport: 'FORM_MENU.OPEN_FORMULIEREN_EXPORT',
        openFormulierenExportClean: 'FORM_MENU.OPEN_FORMULIEREN_EXPORT_CLEAN',
        openFormulierenExportUnmapped: 'FORM_MENU.OPEN_FORMULIEREN_EXPORT_UNMAPPED',
        openFormulierenExportTooLarge: 'FORM_MENU.OPEN_FORMULIEREN_EXPORT_TOO_LARGE',
        openFormulierenExportError: 'FORM_MENU.OPEN_FORMULIEREN_EXPORT_ERROR',
        share: 'FORM_MENU.SHARE',
        makeFormPrivate: 'FORM_MENU.MAKE_FORM_PRIVATE',
        makeFormPublic: 'FORM_MENU.MAKE_FORM_PUBLIC',
        duplicateForm: 'FORM_MENU.DUPLICATE_FORM',
        duplicateError: 'FORM_MENU.DUPLICATE_ERROR',
        generateQr: 'FORM_MENU.GENERATE_QR'
    },
    toolbar: {
        searchPlaceholder: 'FORMS_TOOLBAR.SEARCH_PLACEHOLDER',
        count: 'FORMS_TOOLBAR.COUNT'
    },
    link: 'FORMS_LINK',
    default: 'FORM.DEFAULT',
    pinnedforms: 'PINNED_FORMS',
    all: 'ALL_FORMS',
    unPinForm: 'FORM.UNPIN_FORM',
    shareThisForm: 'SHARE_THIS_FORM',
    emptyDeletionResponseTitle: 'FORM.EMPTY_DELETION_RESPONSE.TITLE',
    deletionRequestDescription: 'FORM.DELETION_REQUEST.DESCRIPTION',
    deletionResponseDescription: 'FORM.DELETION_RESPONSE.DESCRIPTION',
    deletionResponseWarningMessage: 'FORM.DELETION_RESPONSE_WARNING_MESSAGE',
    responseId: 'FORM.RESPONSE_ID',
    empty: {
        title: 'FORM.EMPTY.TITLE',
        description: 'FORM.EMPTY.DESCRIPTION',
        response: {
            title: 'FORM.EMPTY_RESPONSE.TITLE',
            description: 'FORM.EMPTY_RESPONSE.DESCRIPTION'
        },
        deletionRequest: {
            title: 'FORM.EMPTY_DELETION_REQUEST.TITLE',
            description: 'FORM.EMPTY_DELETION_REQUEST.DESCRIPTION'
        }
    },
    importUnlimited: 'FORM.IMPORT_UNLIMITED',
    importedBy: 'FORM.IMPORTED_BY',
    importedOn: 'FORM.IMPORTED_ON',

    addgroup: {
        title: 'FORM.ADD_GROUP.TITLE',
        description: 'FORM.ADD_GROUP.DESCRIPTION',
        label: 'FORM.ADD_GROUP.LABEL'
    },
    respondedOn: 'FORM.RESPONDED_ON',
    requestedOn: 'FORM.REQUESTED_ON',
    settings: {
        description: 'FORM.SETTINGS.DESCRIPTION',
        formLink: {
            title: 'FORM.SETTINGS.FORM_LINK.TITLE',
            description: 'FORM.SETTINGS.FORM_LINK.DESCRIPTION'
        },
        customizeFormLink: {
            title: 'FORM.SETTINGS.CUSTOMIZE_FORM_LINK.TITLE',
            description: 'FORM.SETTINGS.CUSTOMIZE_FORM_LINK.DESCRIPTION',
            List: {
                title: 'FORM.SETTINGS.CUSTOMIZE_FORM_LINK.LIST.TITLE',
                point1: 'FORM.SETTINGS.CUSTOMIZE_FORM_LINK.LIST.POINT_1',
                point2: 'FORM.SETTINGS.CUSTOMIZE_FORM_LINK.LIST.POINT_2'
            }
        },
        pinForm: {
            title: 'FORM.SETTINGS.PIN_FORM.TITLE',
            description: 'FORM.SETTINGS.PIN_FORM.DESCRIPTION'
        },
        visibility: {
            title: 'FORM.SETTINGS.VISIBILITY.TITLE',
            description: 'FORM.SETTINGS.VISIBILITY.DESCRIPTION',
            public: 'FORM.SETTINGS.VISIBILITY.PUBLIC',
            private: 'FORM.SETTINGS.VISIBILITY.PRIVATE'
        }
    },
    group: {
        description: 'FORM.GROUP.DESCRIPTION'
    }
};
